export default [
	{
		path: 'projectAccept',
		component: () => import('@/views/project/accept'),
		name: 'projectAccept',
		meta: { title: '项目验收', icon: 'a-up', noCache: false },
		hidden: true
	},
	{
		path: 'addProject',
		component: () => import('@/views/project/projectForm'),
		name: 'addProject',
		meta: { title: '新增项目', icon: 'a-up', noCache: true },
		hidden: true
	},
	{
		path: 'editProject',
		component: () => import('@/views/project/projectForm'),
		name: 'editProject',
		meta: { title: '编辑项目', icon: 'a-up', noCache: true },
		hidden: true
	},
	{
		path: 'projectDetail',
		component: () => import('@/views/project/projectDetail'),
		name: 'projectDetail',
		meta: { title: '项目详情', icon: 'a-up', noCache: true },
		hidden: true
	},
	{
		path: 'projectPersonImport',
		component: () => import('@/views/project/addPerson/import'),
		name: 'projectPersonImport',
		meta: { title: '项目人员导入', icon: 'a-up', noCache: false },
		hidden: true
	},
	{
		path: '/auditProject',
		component: () => import('@/views/project/auditProject'),
		name: 'auditProject',
		meta: { title: '项目审核', icon: 'a-up', noCache: true },
		hidden: true
	}
]
